import { createFileRoute } from '@tanstack/react-router';
import { AppShell } from '@/components/AppShell';
import { WeeklyReportView } from '@/features/reports/WeeklyReportView';

export const Route = createFileRoute('/reports/weekly')({
  component: () => (
    <AppShell>
      <WeeklyReportView />
    </AppShell>
  ),
});
